import { ReactElement } from 'react'
import VibrationCheckSettingsFormFields from '@editor/components/CheckSettingsFormFields/VibrationCheckSettingsFormFields'
import MultiEditCheckSettings from '../MultiEditCheckSettings'
import { MultiEditCheckSettingsElement } from '../MultiEditCheckSettings/types'
import {
  buildVibrationSettingsRow,
  getVibrationSlabWidth,
  mergeVibrationCheckSettings,
  normalizeVibrationCheckSettings,
  vibrationSettingsColumns,
} from './utils'

interface Props {
  elements: MultiEditCheckSettingsElement[]
}

const MultiEditVibrationCheck = ({ elements }: Props): ReactElement => (
  <MultiEditCheckSettings
    elements={elements}
    sectionKey="vibration"
    settingsLabel="Schwingungs-Einstellungen"
    getSettings={getVibrationSlabWidth}
    normalizeSettings={normalizeVibrationCheckSettings}
    mergeSettings={mergeVibrationCheckSettings}
    differingSettingsMessage="Elemente haben unterschiedliche Deckenbreiten"
    settingsColumns={vibrationSettingsColumns}
    buildSettingsRow={buildVibrationSettingsRow}
    data-cy="vibration-check-form"
    changeButtonDataCy="vibration-check-change-button"
    fields={<VibrationCheckSettingsFormFields memberCheckSettingsSelectedPath="sharedSettings" />}
  />
)

export default MultiEditVibrationCheck
